<template>
  <div :class="wrapperClass" class="llp-datatable-wrapper">
      <DataTable
              ref="dataTable"
              :lazy="lazy"
              :paginator="paginator"
              :rowClass="rowClass"
              :rows="rows"
              :rowsPerPageOptions="rowsPerPageOptions"
              :scrollHeight="scrollHeight"
              :scrollable="scrollable"
              :showGridlines="showGridlines"
              :sortField="sortField"
              :sortMode="sortMode"
              :sortOrder="sortOrder"
              :stripedRows="stripedRows"
              :totalRecords="totalRecords"
              :selectionMode="true" 
              :value="data"
              class="llp-datatable"
              columnResizeMode="fit"
              currentPageReportTemplate="Total: {totalRecords} records"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              resizableColumns
              @page="onPageChange"
              @sort="onSortChange"
              @row-click="onRowClick">
          <template #empty>
           No Data Found
          </template>
          <!-- <ColumnPrime v-if="selectionMode" header="" headerClass="bg-light">
              <template #header>
                  <div class="text-center">
                      <CheckboxPrime v-model="selectAll" :binary="true" :disabled="selectAllDisabled"
                                     @change="invokeSelectAllRows"/>
                      <label class="px-1" hidden @click="()=>{ selectAll = !selectAll; invokeSelectAllRows() }">
                       Select All
                      </label>
                  </div>
              </template>
              <template #body="slotProps">
                  <div class="text-center">
                      <CheckboxPrime v-model="slotProps.data.selected" :binary="true"
                                     :disabled="slotProps.data.disabled"
                                     @change="onChangeCheckboxItem($event)"/>
                  </div>
              </template>
          </ColumnPrime>
          <ColumnPrime
                  v-for="column in columns"
                  :key="column.field"
                  :class="column.className"
                  :field="column.field"
                  :footerClass="'bg-light'"
                  :header="column.header"
                  :headerClass="'bg-light font-weight-bold'"
                  :sortable="column.sortable"
                  :style="column.style">
                  <template v-if="column.isCustomized" #body="slotProps">
                    <slot :data="slotProps.data" :name="column.customizeName"></slot>
                </template>
          </ColumnPrime> -->
          <ColumnPrime
        v-for="column in columns"
        :key="column.field"
        :class="column.className"
        :field="column.field"
        :footerClass="'bg-light'"
        :header="column.header"
        :headerClass="'bg-light font-weight-bold'"
        :sortable="column.sortable"
        :style="column.style"
      >
        <template v-if="column.headerSlot" #header>
          <slot :name="column.headerSlot"></slot>
        </template>

        <template v-if="column.isCustomized" #body="slotProps">
          <slot :data="slotProps.data" :name="column.customizeName"></slot>
        </template>
      </ColumnPrime> 
      </DataTable>
  </div>
</template>
<script>
export default {
name: 'llp-datatable',
emits: ['onPageChange', 'onSortChange', 'onRowClick'],
props: {
  headers: [],
  wrapperClass: {
    type: String,
    default: 'py-4',
  },
  selectionMode: {
    type: Boolean,
    default: false,
  },
  paginator: {
    type: Boolean,
    default: true,
  },
  rows: {
    type: Number,
    default: 10,
  },
  rowsPerPageOptions: {
    type: Array,
    default() {
      return [5, 10, 20, 50];
    },
  },
  scrollable: {
    type: Boolean,
    default: true,
  },
  totalRecords: {
    type: Number,
    default: 0,
  },
  scrollHeight: {
    type: String,
    default: '400',
  },
  showGridlines: {
    type: Boolean,
    default: true,
  },
  stripedRows: {
    type: Boolean,
    default: true,
  },
  sortMode: {
    type: String,
    required: false,
    default: 'single',
  },
  sortField: {
    type: String,
    required: false,
    default: '',
  },
  sortOrder: {
    type: Number,
    required: false,
    default: 1, // 1 as ascending, -1 as descending
  },
  columns: {
    type: Array,
    default: () => [],
  },
  data: {
    type: Array,
    default: () => [],
  },
  selectAllDisabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  selectAllRows: {
    type: Function,
    default: function() {
      this.data.forEach((row) => {
        row.selected = this.selectAll;
      });
    },
  },
  changeCheckboxItem: {
    type: Function,
    default: function() {
    },
  },
  showFooter: {
    type: Boolean,
    default: false,
  },
  lazy: {
    type: Boolean,
    default: false,
  },
  // reference link https://primevue.org/datatable/#conditional_style
  rowClass: {
    type: Function,
    default: function() {
    },
  },
},
data() {
  return {
    selectAll: false,
  };
},
methods: {
  invokeSelectAllRows($event) {
    this.selectAllRows($event, this);
  },
  onChangeCheckboxItem($event) {
    // update selectAll when a checkbox is changed
    this.selectAll = this.data.filter(row => row.selected).length === this.data.length;

    this.changeCheckboxItem($event, this);
  },
  onPageChange($event) {
    this.selectAll = false;
    this.$nextTick(() => {
      this.$emit('onPageChange', $event);
    });
  },
  onSortChange($event) {
    this.selectAll = false;
    this.$nextTick(() => {
      this.$emit('onSortChange', $event);
    });
  },
  onRowClick($event) {
    this.$nextTick(() => {
      this.$emit('onRowClick', $event);
    });
  },
  resetPaginator() {
    this.selectAll = false;
    this.$refs.dataTable.d_first = 0;
    this.$refs.dataTable.d_rows = this.rows;
  },
},
mounted() {
},
};
</script>

